export default __webpack_public_path__ + "static/media/colab3.0599d95f.svg";